/*
 * `modules/textSplit.js`
 *  - テキストを `span` でラップ（アニメーション用）
 *
 * 使用方法:
 *  - import {textSplit} from "./textSplit.js";
 *  - TextSplit.apply("[data-txt-anim~=split]"); // 一括適用
 *  - new TextSplit(document.querySelector(".js-txt-up")); // 単体適用
 */

class TextSplit {
  /**
   * コンストラクタ
   * @param {HTMLElement | string} target - ラップする要素（HTML要素 or セレクタ）
   */
  constructor(target) {
    this.target = this.getElement(target);
    if (!this.target) {
      console.warn("⚠️ textSplit: 指定された要素が見つかりません。");
      return;
    }
    this.nodes = [...this.target.childNodes];
    this.wrapText();
  }

  /**
   * テキストを `span` でラップ
   */
  wrapText() {
    let spanWrappedText = "";

    this.nodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        // テキストノードの場合、改行削除 & spanでラップ
        const text = node.textContent.replace(/\r?\n/g, "");
        spanWrappedText += text.split("").map(char =>
          char === " " ? `<span class="_txt _s">${char}</span>` : `<span class="_txt">${char}</span>`
        ).join("");
      } else {
        // `<br>` などの要素はそのまま保持
        spanWrappedText += node.outerHTML;
      }
    });

    this.target.innerHTML = spanWrappedText;
  }

  /**
   * 指定された要素を取得
   * @param {HTMLElement | string} element
   * @returns {HTMLElement | null}
   */
  getElement(element) {
    if (element instanceof HTMLElement) return element;
    return document.querySelector(element);
  }

  /**
   * 指定したセレクタのすべての要素に適用
   * @param {string} selector - 適用する要素のセレクタ
   */
  static apply(selector) {
    document.querySelectorAll(selector).forEach((el) => new TextSplit(el));
  }
}

export default TextSplit;